import { RegularInterviewMyDataResponse } from '~/types/MyData';

export interface MyDataApi {
  /** コンディションサーベイマイデータ取得 */
  getRegularInterviewMyData: (periods: string[]) => Promise<RegularInterviewMyDataResponse>;
}

export const useMyDataApi = (fetch): MyDataApi => {
  /** コンディションサーベイマイデータ取得 */
  const getRegularInterviewMyData = async (periods: string[]): Promise<RegularInterviewMyDataResponse> => {
    const queryParams = new URLSearchParams();
    periods.forEach((period) => {
      queryParams.append('periods[]', period);
    });
    const response = await fetch(`my-data/regular-interview?${queryParams}`);
    return response.data;
  };

  return {
    getRegularInterviewMyData,
  };
};
